
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { GenerateRoutesRequest, PlanWithJobRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GenerateRouteUsecase implements UseCase<GenerateRoutesRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: GenerateRoutesRequest): Observable<boolean> {
    return this.planRepository.generateRoutes(params);
  }

}